<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="success" small>
        <v-icon class="mr-1">add</v-icon>
        {{ $t("Button.Add") }}..
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          Add Alias
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <AliasForm v-if="dialog" ref="form" :givenStation="currentContinuousStation" @close="close()" />
      <v-card-actions>
        <v-spacer />
        <v-btn color="success" :loading="loading" @click="submit()">
          <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn outline color="secondary" @click="close()" :disabled="loading">
          {{ $t('Button.Cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import AliasForm from './AliasForm'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    components: {
      AliasForm,
    },
    data() {
      return {
        dialog: false,
        loading: false,
      }
    },
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType']),
      ...dataSources.mapGetters(['dataSourceIndex']),
      continuousDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.continuousAquarius]
      },
      continuousStationsIndex() {
        return this.dataSourceIndex[SOURCE_TYPES.continuousAquarius] || []
      },
      currentContinuousStation() {
        return this.continuousStationsIndex[this.continuousDataSource.SourceId]
      },
    },
    methods: {
      show() {
        this.dialog = true
      },
      close() {
        this.dialog = false
      },
      async submit() {
        this.loading = true
        await this.$refs.form.submit()
        this.loading = false
      },
    },
  }
</script>